import { InMemoryCache } from '@apollo/client/cache/inmemory/inMemoryCache.js';
import { ApolloClient } from '@apollo/client/core/ApolloClient.js';
import { split } from '@apollo/client/link/core/split.js';
import { getMainDefinition } from '@apollo/client/utilities/index.js';
import { Kind, OperationTypeNode } from 'graphql';
import { useMemo } from 'react';
import { httpLink } from './apollo/httplink';
import { wsLink } from './apollo/websocketlink';
// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value
const splitLink = ({ token, url, wsUrl, }) => split(({ query }) => {
    const definition = getMainDefinition(query);
    return (definition.kind === Kind.OPERATION_DEFINITION &&
        definition.operation === OperationTypeNode.SUBSCRIPTION);
}, wsLink({ token, url: wsUrl }), httpLink({ token, url }));
export function createHttpClient({ token, url, }) {
    return new ApolloClient({
        link: httpLink({ token, url }),
        cache: new InMemoryCache(),
    });
}
export function createClient({ token, url, wsUrl, }) {
    if (token) {
        return new ApolloClient({
            link: splitLink({ token, url, wsUrl }),
            cache: new InMemoryCache(),
        });
    }
    return createHttpClient({ token, url });
}
export function useAuthApolloClient(token, url, wsUrl, skip = false) {
    const apolloInstance = useMemo(() => {
        if (skip)
            return undefined;
        return createClient({ token, url, wsUrl });
    }, [skip, token, wsUrl, url]);
    return apolloInstance;
}
//# sourceMappingURL=client.js.map